export enum ContentType {
    Unknown = 0,
    Gallery = 'gallery',
    Podcast = 'podcast',
    Video = 'video',
    GlomexVideo = 'glomexvideo',
    DailyMotionVideo = 'dailymotionvideo',
    Article = 'article',
    Ressort = 'ressort',
    TeaserModule = 'teasermodule',
    Image = 'image',
    InfoBox = 'infobox',
    InfoBoxTeaser = 'infoboxteaser',
    Linkbox = 'linkbox',
    FreeText= 'freetext',
    CollectiveBox = 'collectivebox',
    CollectiveSwipe = 'collectiveswipe',
    FreeHtml = 'freehtml',
    Advert = 'advert',
    QualifioBox = 'qualifiobox',
    Liveticker = 'liveticker',
    KickerMatchday = 'kickermatchday',
    Landingpage = 'Landingpage',
    MyRessortHeadline = 'myressortheadline',
    MyRessortLoadRessort = 'myressortloadressort',
    TwentyThreeDegrees = 'twentythreedegrees',
    SearchModule = 'searchmodule',
    Movie = 'movie',
    KickerLiveTicker = 'kickerliveticker',
    TwentyThreeDegreesModule = 'twentythreedegreesmodule',
    LinkResource = 'linkresource',
    Unscaled = 'unscaled',
    AffiliateBox = 'affiliatebox',
    MasonryModule = 'masonrymodule',
    StoryModule = 'storymodule',
    HighlightModule = 'highlightmodule',
    ListModule = 'listmodule',
    Catchline = 'catchline',
    AmazonAffiliateBox = 'amazonaffiliatebox',
    Faq = 'faq'
  };

  export enum PageType {
    Homepage = "homepage",
    Ressort = "ressort",
    Article = "article"
  };


export enum CmpIdentifier {
  Glomex = 'glomex.com',
  TwentyThreeDegrees = '23degrees.io',
  DailyMotion = 'dailymotion.com',
  Facebook = 'facebook.com',
  ChartBeat = 'chartbeat.com',
  AtInternet = 'atinternet.com',
  Piano = 'piano.io',
  Outbrain = 'outbrain.com',
};

export enum CmpProvider {
  CleverPush = "s1474",
}

  export enum CmpPurpose {
    Necessary = 'c1',
    One = '1',
    Seven = '7',
    Eight = '8',
    Nine = '9',
  };

  export enum CategoryType {
    Unknown = '',
    Home = 'home',
    Ressort = 'ressort',
    Article = 'article'
  };

  export enum NavigationType {
    Internal = "internal",
    ExternalBack = "external-back",
    ExternalReload = "external-reload",
    ExternalNavigateTo = "external-navigate-to",
    ExternalNavigateToWithoutNotification = "external-navigate-to-without-navigation"
  };

  export enum LinkType {
    Self = "self",
    External = "external",
    Enclosure = "enclosure",
    LinkResource = "linkresource",
    NoFollow = "nofollow",
    WebView = "webview",
    Contact = "contact"
  }

  export enum AdType {
    Mobile = 1,
    Native = 2
  };

  export enum AppTheme {
    nn = 'nn',
    nb = 'nb',
  }

export enum LocalStorageType {
  User = 'user',
  PageId = 'pageId',
  PersonalResorts = "PersonalResorts",
  BookmarkIds = "BookmarkIds",
  // Cached appInfo.platform, so the pre-paint device-font-scale script knows the
  // platform before the native setAppInfo callback arrives. The inline script in
  // helper/deviceFontScale.ts repeats this value as a literal.
  Platform = 'platform'
}

  export enum Newspaper {
    NuernbergerNachrichten = 'logo-nuernberger-nachrichten',
    ErlangerNachrichten = 'logo-erlanger-nachrichten',
    TreuchtlingerKurier = 'logo-treuchtlinger-kurier',
    DerBote = 'logo-der-bote',
    SchwabacherTagblatt = 'logo-schwabacher-tagblatt',
    HilpoltsteinerZeitung = 'logo-hilpoltsteiner-zeitung',
    FuertherNachrichten = 'logo-fuerther-nachrichten',
    NeumarkterNachrichten = 'logo-neumarkter-nachrichten',
    AltmuehlBote = 'logo-altmuehl-bote',
    NordbayerischeNachrichten = 'logo-nordbayerische-nachrichten',
    PegnitzZeitung = 'logo-pegnitz-zeitung',
    RothHilpoltsteinerVolkszeitung = 'logo-roth-hilpoltsteiner-volkszeitung',
    HersbruckerZeitung = 'logo-hersbrucker-zeitung'
  }

  export enum ImageFormat {
    Format_16_9 = '16:9',
    Format_4_3 = '4:3',
    Format_1_1 = '1:1',
    Format_8_3 = '8:3',
    Format_9_16 = '9:16',
    Format_2_3 = '2:3',
  }

  export enum ImageWidth {
    Width_2400 = 2400,
    Width_1000 = 1000,
    Width_600 = 600,
    Width_500 = 500,
    Width_150 = 150
  }

  export enum ImageOrientationType {
    Landscape = "landscape",
    Portrait = "portrait"
  }

  export enum EventCategoryType {
    Ressort,
    Detail,
    Web
  }

  export enum backendEnvironment { 
    staging, 
    test, 
    pre 
  }

  export enum SportsTickerEventType {
    YellowCard,
    RedCard,
    YellowRedCard,
    Goal,
    Substitution,
    Penalty,
    PenaltyMiss,
    VideoAssist,
    Ad,
    SpecialEvent,
    StartEnd,
    Unknown
  }

  export enum MatchState {
    Pre,
    Live,
    Finished
  }

  export enum GalleryVotingType {
    Rating = "rating",
    Voting = "voting"
  }

  export enum MenuSteps {
    Favourites = 'favourites',
    SearchFav = 'searchFav',
    EditPersonal = 'editPersonal'
  }



  export enum TeaserViewType {
    Masonry = 'Masonry',
  }

  export enum ListIconsEnum {
    List= 'list',
    Star = 'star',
    Globe = 'globe',
    Heart = 'heart',
  }